import React, { useRef, memo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import images from "@app/images";
import { useAccount } from "@redux/account";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ReactComponent as IcnLoginProfile } from "@assets/svg/icn_login_profile.svg";
import { ReactComponent as IcnLoginPassword } from "@assets/svg/icn_login_password.svg";
import { DefaultContainedButton } from "@assets/buttons";
import { IconTextField01 } from "@assets/TextField";
import { useMenuDispatch } from "@assets/contexts/MenuContext";

const CompLogin = memo(() => {
  const account = useAccount();
  const value = useMenuDispatch(); // function  context
  const idEl = useRef(null);
  const pwEl = useRef(null);
  const navigate = useNavigate();

  const handleLogin = useCallback(() => {
    const memberId = idEl.current.value;
    const memberpw = pwEl.current.value;
    if (memberId === undefined || memberId === "") {
      alert("유저 이름을 확인해주세요.");
      idEl.current.focus();
      return false;
    }
    if (memberpw === undefined || memberpw === "") {
      alert("비밀번호를 확인해주세요.");
      pwEl.current.focus();
      return false;
    }
    value({ type: "loadingStart" });
    account.login(memberId, memberpw, (data, response) => {
      if (response.status === 200 && data?.error === undefined) {
        value({ type: "userset", payload: data.permission });
        value({ type: "loadingEnd" });
        navigate("/", { replace: true });
      } else {
        value({ type: "loadingEnd" });
        const errorMessage = response?.data?.error?.message || "서버에 연결할 수 없습니다.";
        alert(errorMessage);
      }
    });
  }, [account, navigate, value]);

  const handlePress = useCallback(
    (e) => {
      if (e.keyCode === 13) {
        handleLogin();
      }
    },
    [handleLogin]
  );

  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="column"
        sx={{ height: "100%" }}
      >
        <Grid
          sx={{
            height: "662px",
            width: "550px",
            borderRadius: "24px",
            border: "1px solid #EEEEEF",
            bgcolor: "#ffffff",
            pl: 9.375,
            pr: 9.375,
            pt: 16,
            pb: 10.5,
          }}
        >
          <Box
            component="form"
            fullWidth
            sx={{
              width: "100%",
              textAlign: "center",
              "& .MuiTextField-root": {
                pt: 0.5,
                pb: 0.5,
                width: "100%",
              },
              "& input": {
                pl: 1,
                pt: 1.75,
                pb: 1.625,
                fontSize: "16px",
              },
            }}
          >
            <Grid
              container
              justifyContent="center"
              direction="row"
              sx={{ pb: 8.75 }}
            >
              <img
                alt="열나요 로고"
                src={images.login_logo.default}
                width={95}
                height={95}
              />
              <Box sx={{ ml: 2 }}>
                <Grid
                  container
                  direction="column"
                  justifyContent="center"
                  sx={{ height: "100%" }}
                >
                  <img
                    alt="열나요"
                    src={images.login_logo_title.default}
                    width={90}
                    height={35}
                  />
                  <Box sx={{ pt: 0.5 }}>
                    <Typography
                      variant="h3"
                      fontWeight={500}
                      sx={{ color: "grey.600" }}
                    >
                      광고 관리페이지
                    </Typography>
                  </Box>
                </Grid>
              </Box>
            </Grid>
            <IconTextField01
              inputRef={idEl}
              placeholder={"아이디"}
              onKeyDown={handlePress}
              icon={<IcnLoginProfile className="icon_arrow" />}
            />
            <IconTextField01
              inputRef={pwEl}
              inputCase={"password"}
              placeholder={"비밀번호"}
              onKeyDown={handlePress}
              icon={<IcnLoginPassword className="icon_arrow" />}
            />
            <FormGroup aria-label="position" row>
              <FormControlLabel
                value="end"
                control={
                  <Checkbox
                    icon={<PanoramaFishEyeIcon sx={{ fontSize: 24 }} />}
                    checkedIcon={<CheckCircleIcon sx={{ fontSize: 24 }} />}
                    color="info"
                  />
                }
                label={<Typography variant="body">로그인 저장</Typography>}
                labelPlacement="end"
              />
            </FormGroup>
            <Grid container justifyContent="center" sx={{ pt: 8.75 }}>
              <DefaultContainedButton
                color="secondary"
                fullWidth={true}
                height={56}
                borderColor="secondary.main"
                fontWeight={500}
                text="로그인"
                onClick={handleLogin}
              />
            </Grid>
          </Box>
        </Grid>
        <Typography
          variant="body2"
          fontWeight="400"
          color="grey.600"
          sx={{ mt: 2.5 }}
        >
          로그인이 안되는 경우, contact@fevercoach.net 으로 문의주시길 바랍니다.
        </Typography>
      </Grid>
    </>
  );
}, []);

export default CompLogin;
